// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, {Component} from 'react'
import { Router, Route, IndexRoute, browserHistory } from 'react-router'

import { AddWorker } from '../containers/addWorker'
import { AssignTraining } from '../containers/assignTraining'
import { AssignTrainingIndividuals } from '../containers/assignTrainingIndividuals'
import { AssignTrainingModules } from '../containers/assignTrainingModules'
import { Dashboard } from '../containers/dashboard'
import { ForgotPassword } from '../containers/forgotPassword'
import { Help } from '../containers/help'
import { Leaderboards } from '../containers/leaderboards'
import { Login } from '../containers/login'
import { ManageCategories } from '../containers/manageCategories'
import { ManageInvites } from '../containers/manageInvites'
import { ModuleListing } from '../containers/moduleListing'
import { PasswordReset } from '../containers/passwordReset'
import { Performance } from '../containers/performance'
import { PerformanceDetails } from '../containers/performanceDetails'
import { PerformanceSummary } from '../containers/performanceSummary.js'
import { PerformanceSummaryContent } from '../containers/performanceSummaryContent'
import { Profile } from '../containers/profile'
import { ProviderContent } from '../containers/providerContent'
import { Register } from '../containers/register'
import { Settings } from '../containers/settings'
import { Store } from '../containers/store'
import { Template } from '../containers/template'
import { WorkerCertificate } from '../containers/workerCertificate'
import { WorkerContent } from '../containers/workerContent'
import { WorkerProfile } from '../containers/workerProfile'
import { WorkerResults } from '../containers/workerResults'
import { WorkerStore } from '../containers/workerStore'
import { Workforce } from '../containers/workforce'
import { WorkforceSummary } from '../containers/workforceSummary'
import { WorkforceSummaryWorkerContent } from '../containers/workforceSummaryWorkerContent'
import { WorkforceWorkerPerformance } from '../containers/workforceWorkerPerformance'

class Routes extends Component {
    render() {
	  	return (
	  		<Router
				history = { browserHistory }		
			>
			    <Route
				    path='/'
				    component={ Template }
				>
			    	<IndexRoute
			    		component={ Login }
			    	/>
			    	<Route
			    		path = '/login'
			    		component = { Login }
			    	/>
			    	<Route
			    		path = '/register'
			    		component = { Register }
			    	/>
			    	<Route
			    		path='/dashboard'
			    		component = { Dashboard }
			    	/>
			    	<Route
			    		path='/dashboard/profile'
			    		component = { Profile }
			    	/>
			    	<Route
			    		path='/profile'
			    		component = { Profile }
			    	/>
			    	<Route
			    		path='/dashboard/profile/module'
			    		component = { ModuleListing }
			    	/>
			    	<Route
			    		path='/profile/module'
			    		component = { ModuleListing }
			    	/>
			    	<Route
			    		path='/module'
			    		component = { ModuleListing }
			    	/>
			    	<Route 
			    		path='/settings'
			    		component = { Settings }
			    	/>
			    	<Route
			    		path='/addIndividual'
			    		component = { AddWorker }
			    	/>
			    	<Route
			    		path='/forgotPassword'
			    		component={ ForgotPassword }
			    	/>
			    	<Route
			    		path='/passwordReset'
			    		component={ PasswordReset }
			    	/>

			    	<Route
			    		path='/workforce'
			    		component={ Workforce }
			    	>
			    		<IndexRoute				    		
				    		component={ WorkforceSummary }
				    	/>
				    	<Route
				    		path='/workforce/summary'
				    		component={ WorkforceSummary }
				    	/>
				    	<Route
				    		path='/workforce/summary/content'
				    		component={ WorkforceSummaryWorkerContent }
				    	/>
				    	<Route
				    		path='/workforce/summary/content/performance'
				    		component={ WorkforceWorkerPerformance }
				    	/>
			    	</Route>

			    	<Route 
			    		path='/performance'
			    		component={ Performance }
				    >
				    	<IndexRoute
				    		component={ PerformanceSummary }
				    	/>
				    	<Route
				    		path='/performance/summary'
				    		component={ PerformanceSummary }
					    />
				    	<Route
				    		path='/workforce/performanceSummary'
				    		component={ PerformanceSummary }
					    />
					    <Route
				    		path='/performance/summary/content'
				    		component={ PerformanceSummaryContent }
					    />
					    <Route 
					    	path='/performance/summary/content/details'
					    	component = { PerformanceDetails }
					    />
					</Route>

			    	<Route
			    		path='/assignTraining'
			    		component={ AssignTraining }
			    	>
			    		<IndexRoute				    		
				    		component={ AssignTrainingIndividuals }
				    	/>
				    	<Route
				    		path='/assignTraining/individuals'
				    		component={ AssignTrainingIndividuals }
				    	/>
				    	<Route
				    		path='/assignTraining/modules'
				    		component={ AssignTrainingModules }
				    	/>
				    </Route>

			    	<Route
			    		path='/providerContent'
			    		component={ ProviderContent }
			    	/>

			    	<Route
			    		path='/store'
			    		component={ Store }
			    	/>

			    	<Route
			    		path='/workerStore'
			    		component={ WorkerStore }
			    	/>

			    	<Route
			    		path='/manageCategories'
			    		component={ ManageCategories }
			    	/>

			    	<Route
			    		path='/leaderboards'
			    		component={ Leaderboards }
			    	/>

			    	<Route
			    		path='/help'
			    		component={ Help }
			    	/>

			    	<Route
			    		path='/individual'
			    		component={ WorkerProfile }
			    	>
			    		<IndexRoute				    		
				    		component={ WorkerContent }
				    	/>
				    	<Route
				    		path='/individual/trainingContent'
				    		component={ WorkerContent }
				    	/>
				    	<Route
				    		path='/individual/results'
				    		component={ WorkerResults }
				    	/>
				    	<Route
				    		path='/individual/certificate'
				    		component={ WorkerCertificate }
				    	/>
				    </Route>

				    <Route
			    		path='/manageInvites'
			    		component={ ManageInvites }
			    	/>
			     
			    </Route>
		   </Router>
		)
	}
}

export default Routes


// WEBPACK FOOTER //
// ./src/routes/index.js